import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getProductSeatUnassignBulkProgress,
    stopProductSeatUnassignBulk,
    unassignProductSeatBulk,
} from 'src/openapi/admin/apis/BulkProductSeatUnassignmentApi';
import {useAppDispatch} from 'src/store/hooks';

import {MODAL_WIDTH, TOOL_PROGRESS_LABEL, TOOL_STACK_OVERFLOW_MESSAGE, TOOL_TASK, TOOL_TITLE} from './constants';
import {UnassignProductSeatModal} from './unassign-product-seat.modal';
import {
    selectUnassignProductSeatTask,
    selectUnassignProductSeatUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from './unassign-product-seat.slice';

import type {UnassignProductSeatRequest} from 'src/openapi/admin/models/UnassignProductSeatRequest';

type Props = {shown: boolean, accountId: number, userIds: number[], onDone: () => void, onClose: () => void};
export const UnassignProductSeatTool = ({shown, accountId, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();
    return (
        <BulkActionTool<UnassignProductSeatRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}
            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}
            taskSelector={selectUnassignProductSeatTask}
            uuidSelector={selectUnassignProductSeatUuid}
            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(request, options) => (
                apiDispatch(unassignProductSeatBulk({...options, unassignProductSeatRequest: request}))
            )}
            getProgress={id => apiDispatch(getProductSeatUnassignBulkProgress({id}))}
            stopAction={id => apiDispatch(stopProductSeatUnassignBulk({id}))}
            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) =>
                <UnassignProductSeatModal {...{accountId, userIds, onCloseModal, processAction}}/>}
        </BulkActionTool>
    );
};
